export default __webpack_public_path__ + "static/media/setting_inactive.7b3ff80c.svg";